import { TemplateParamsKey } from 'features/my-gift-cards/ts/CartPreviewTemplateParams';

const templateVariablesDictionary = {
  expiresAt: '{{ expiry_date }}',
} as Record<TemplateParamsKey, string>;
export const toTemplateVariable = (key: TemplateParamsKey) => {
  if (templateVariablesDictionary[key]) {
    return templateVariablesDictionary[key];
  }

  return `{{ ${key} }}`;
};
